import { memo } from 'react';
import { UserRegister3Template2 } from 'components/templates/UserRegister3Template2';

type Props = {};

export const UserRegister3Page2 = memo((_props: Props) => {
	return <UserRegister3Template2 />;
});
